<template>
    <!-- <AdminLayout> -->
      <section class="flex items-start">
        <div class="w-full">
          <div class="mt-12">
            <div class="border rounded-lg py-7 px-8">
              <div class="flex justify-between mb-5">
                <p class="font-semibold text-xl text-neutral-800">Attendance Adjustment 2025</p>
              </div>
  
              <!-- Header Row -->
              <div class="grid grid-cols-5 bg-slate-200 divide-x-[1px] divide-white rounded-t-md">
                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">Application Type:</div>
                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">Name:</div>
                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal">Employee ID:</div>
                <div class="text-sm leading-none px-2 py-3 flex items-center font-normal col-span-2">Pick date:</div>
              </div>
  
              <!-- Input Row -->
              <div class="grid grid-cols-5 bg-white divide-x-[1px] divide-neutral-200 rounded-b-md border-r border-b border-l border-neutral-200 py-4 mb-6">
                <div class="text-sm leading-none px-2 flex items-center font-normal">
                  <select v-model="selectedOption" class="text-sm text-black border rounded px-3 py-2 w-full">
                    <option value="Attendance">Attendance</option>
                    <option value="Leave">Leave</option>
                  </select>
                </div>
                <div class="text-sm leading-none px-2 flex items-center font-normal">
                  <select v-model="selectedUid" class="text-sm text-black border rounded px-3 py-2 w-full">
                    <option :value="null" disabled>Select Name</option>
                    <option v-for="emp in empdata" :key="emp.uid" :value="emp.uid">
                      {{ emp.fname }} {{ emp.lname }}
                    </option>
                  </select>
                </div>
                <div class="text-sm leading-none px-2 flex items-center font-normal">
                  <input type="text" :value="getSelectedEmployeeId" readonly class="text-sm text-black border rounded px-3 py-2 w-full" />
                </div>
                <div class="text-sm leading-none px-2 flex items-center font-normal col-span-2">
                  <div class="flex space-x-2">
                    <Datepicker v-model="date" placeholder="Select a date" />
                    <button v-if="selectedOption === 'Attendance'" type="button" class="bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal" @click="getAttendanceData">Get Details</button>
                    <button type="reset" class="bg-red-400 rounded-md px-3 py-2 text-white text-xs font-normal" @click="clearAllAttendanceData()">Clear</button>
                  </div>
                </div>
              </div>
  
              <!-- Attendance Form -->
              <div v-if="selectedOption === 'Attendance'" class="border py-3 border-neutral-200 rounded-md">
                <div class="grid grid-cols-3 gap-y-4 divide-x-[1px] divide-neutral-200">
                  <div class="px-3">
                    <p class="text-sm mb-2 font-medium text-black">Check in time</p>
                    <input type="time" v-model="checkInTime" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black" />
                  </div>
                  <div class="px-3">
                    <p class="text-sm mb-2 font-medium text-black">Check out time</p>
                    <input type="time" v-model="checkOutTime" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black" @change="getTotalTime()"/>
                  </div>
                  <div class="px-3">
                    <p class="text-sm mb-2 font-medium text-black">Total working hours</p>
                    <input type="text" v-model="totalHours" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black" readonly/>
                  </div>
                  <div class="px-3 col-span-3 -ml-[1px]">
                    <p class="text-sm mb-2 font-medium text-black">Remark</p>
                    <textarea v-model="attendanceRemark" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black"></textarea>
                  </div>
                </div>
                <div class="flex items-center space-x-3 p-3">
                  <button type="button" class="bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal" @click="saveAttendanceTime()" :disabled="buttonclick" :class="buttonclick == true ? 'opacity-50 cursor-not-allowed' : ''">
                    <span class="pr-2">
                      Add Manual Time
                    </span>
                    <span>
                        <span v-if="this.btnLoader" class="animate-spin h-4 w-4 inline-block border-2 border-white border-r-white/10 border-t-white/10 rounded-full"></span>
                    </span>
                  </button>
                  <button type="button" class="bg-red-400 rounded-md px-3 py-2 text-white text-xs font-normal" @click="clearAttendanceDetails()">Remove Data</button>
                </div>
              </div>
  
              <!-- Leave Form -->
              <div v-if="selectedOption === 'Leave'" class="border py-3 border-neutral-200 rounded-md">
                <div class="grid grid-cols-2 gap-y-4">
                  <div class="px-3">
                    <p class="text-sm mb-2 font-medium text-black">Leave type</p>
                    <select v-model="leaveType" class="text-sm text-black border rounded px-3 py-2 w-full">
                      <option disabled value="">Select Leave</option>
                      <option v-for="leave in leaveOptions" :key="leave.id" :value="leave.id">
                        {{ leave.leave_name }}
                      </option>
                    </select>
                  </div>
                  <div class="px-3 border-l border-neutral-200">
                    <p class="text-sm mb-2 font-medium text-black">Upload File</p>
                    <input type="file" @change="handleFileUpload" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black" />
                  </div>
                  <div class="px-3 col-span-2">
                    <p class="text-sm mb-2 font-medium text-black">Remark</p>
                    <textarea v-model="leaveRemark" class="border border-neutral-200 rounded-md block w-full px-2 py-1 text-black"></textarea>
                  </div>
                </div>
                <div class="flex items-center space-x-3 p-3">
                  <button type="button"   @click="submitLeaveRequest" class="bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal">Add Leave</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <RightSideBar /> -->
      </section>
    <!-- </AdminLayout> -->
  </template>
  
  <script>
  import axios from 'axios';
  // import AdminLayout from '../AdminDashboard/AdminLayout.vue';
  // import RightSideBar from '../../components/RightSideBar.vue';
  import Datepicker from 'vue3-datepicker';
  import { BASE_URL } from '../../config';
  import { createToast } from 'mosha-vue-toastify';
  export default {
    name: 'AttendanceAdjustment',
    components: {
      // AdminLayout,
      // RightSideBar,
      Datepicker
    },
    data() {
      return {
        buttonclick: false,
        btnLoader: false,
        selectedOption: 'Attendance',
        date: null,
        selectedUid: null,
        empdata: [],
        leaveOptions: [],
        checkInTime: '',
        checkOutTime: '',
        totalHours: '',
        attendanceRemark: '',
        leaveType: '',
        leaveFile: null,
        leaveRemark: '',
        attendanceId: '',
      };
    },
    computed: {
      getSelectedEmployeeId() {
        if (!this.empdata || !this.selectedUid) return '';
        const emp = this.empdata.find(e => e.uid === this.selectedUid);
        return emp ? emp.empid : '';
      }
    },
    methods: {
      formatDate(date) {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      },

      formatTime(time) {
        let date = new Date(time); // convert string to number and to Date
        let hours = date.getHours().toString().padStart(2, '0'); // get hours and pad
        let minutes = date.getMinutes().toString().padStart(2, '0'); // get minutes and pad
        return `${hours}:${minutes}`;
      },

      tostMessage(status,message){
        createToast({
          // title: title,
          description: message
        },
        {
          type: status,
          timeout: 2500,
          position: 'bottom-right',
          showIcon: 'true'
        })
      },

      async fetchempdetails() {
        try {
          const response = await axios.post(BASE_URL + '/get-all-employee-data', {
            'company_id': localStorage.getItem('company_id'),
          });
          this.empdata = response.data.userdetails;
        } catch (error) {
          console.error('Failed to fetch employee data:', error);
        }
      },

      async fetchLeaveOptions() {
        if (!this.selectedUid) return;
        try {
          const response = await axios.post(BASE_URL + '/admin-leave-records', {
            user_id: this.selectedUid
          });
          this.leaveOptions = response.data || [];
        } catch (error) {
          console.error('Error fetching leave options:', error);
        }
      },

      resetForm() {
        this.leaveType = '';
        this.selectedUid = '';
        this.date = '';
        this.leaveRemark = '';
        this.leaveFile = null;
      },

      async submitLeaveRequest() {
      
        if (!this.leaveType || !this.selectedUid || !this.date || !this.leaveRemark) {
          this.tostMessage('danger','Please fill in all the required fields.');
          return;
        }

        const formData = new FormData();
        formData.append('leave_type_id', this.leaveType);
        formData.append('uid', this.selectedUid);
        formData.append('start_date', this.formatDate(this.date));
        formData.append('end_date', this.formatDate(this.date));
        formData.append('reason', this.leaveRemark);

        if (this.leaveFile) {
          formData.append('document', this.leaveFile);
        }

        try {
          const response = await axios.post(BASE_URL + '/admin-leave-requests', formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          }
          });
          //alert('Leave request submitted successfully!');
          console.log('Leave API response:', response.data);
          this.tostMessage('success', response.data.message);
          this.resetForm(); 
        } catch (error) {
          //console.error('Error submitting leave request:', error.response);
          //alert('Failed to submit leave request.');
          this.tostMessage('danger',error.response?.data?.error);
        }
      },

      handleFileUpload(event) {
        this.leaveFile = event.target.files[0];
      },

      getTotalTime() {
        // Split hours and minutes
        let [startHours, startMinutes] = this.checkInTime.split(':').map(Number);
        let [endHours, endMinutes] = this.checkOutTime.split(':').map(Number);

        // Convert both to minutes since midnight
        let startTotalMinutes = startHours * 60 + startMinutes;
        let endTotalMinutes = endHours * 60 + endMinutes;

        // Find the difference
        let diffMinutes = endTotalMinutes - startTotalMinutes;

        // If the end time is earlier than the start time, assume it crosses midnight
        if (diffMinutes < 0) {
          diffMinutes += 24 * 60;
        }

        // Convert back to hours and minutes
        let hours = Math.floor(diffMinutes / 60);
        let minutes = diffMinutes % 60;

        this.totalHours = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      },

      async getAttendanceData(){
        const formData = {
          "employee_id": this.selectedUid,
          "date": this.formatDate(this.date),
        };
        console.log("FORM DATA: ", formData);
        await axios.post(BASE_URL + '/get-attendance-details-for-adjustment', formData)
        .then((response) => {
          // this.recordList = response.data.recordTotal;
          if(response.data.attendanceRecord){
            this.checkInTime = this.formatTime(response.data.attendanceRecord
            .check_in);

            if(response.data.attendanceRecord.check_out !== ""){              
              this.checkOutTime = this.formatTime(response.data.attendanceRecord.check_out);
            }
            this.totalHours = response.data.attendanceRecord
            .total_hours;
            this.attendanceRemark = response.data.attendanceRecord
            .note;
            this.attendanceId = response.data.attendanceRecord.id;
          }else{
            this.clearAttendanceDetails();
            this.attendanceId= '';
          }

        })
      },

      async saveAttendanceTime(){
        if (!this.checkInTime || !this.checkOutTime || !this.totalHours || !this.attendanceRemark) {
          this.tostMessage('danger','Please fill in all the required fields.');
          return;
        }
       
        let formData = {};
        if(this.attendanceId === ''){
          formData = {
            "employee_id": this.selectedUid,
            "date": this.formatDate(this.date),
            "check_in": this.checkInTime,
            "check_out": this.checkOutTime,
            "total_hours": this.totalHours,
            "remark": this.attendanceRemark,
            "company_id": localStorage.getItem('company_id')
          };
          // formData.id = null;
        }else{
          formData = {
            "employee_id": this.selectedUid,
            "date": this.formatDate(this.date),
            "check_in": this.checkInTime,
            "check_out": this.checkOutTime,
            "total_hours": this.totalHours,
            "remark": this.attendanceRemark,
            "id": this.attendanceId
          };
          
        }    
        this.btnLoader = true;
        this.buttonclick = true;
        await axios.post(BASE_URL + '/save-attendance-adjustment-details', formData)
          .then((response) => {
              if(response.data.success === 'success'){
                this.clearAttendanceDetails();
                this.btnLoader = false;
                this.buttonclick = false;
                this.tostMessage('success', response.data.message);
              }else{
                this.clearAttendanceDetails();
                this.btnLoader = false;
                this.buttonclick = false;
                this.tostMessage('danger', response.data.error);
              }
          });   
      },
      clearAttendanceDetails() {
        this.checkInTime = '';
        this.checkOutTime = '';
        this.totalHours = '';
        this.attendanceRemark = '';
        // this.attendanceId= '';
      },

      clearAllAttendanceData() {
        this.clearAttendanceDetails();
        this.selectedUid = null;
        this.date = null;
      }
    },
    watch: {
      selectedUid(newVal) {
        console.log('UID changed to:', newVal);
        if (this.selectedOption === 'Leave' && newVal) {
          this.fetchLeaveOptions();
        }
        if (this.selectedOption === 'Attendance' && newVal) {
          this.fetchLeaveOptions();
        }
        
      },
      selectedOption(newVal) {
        if (newVal === 'Leave' && this.selectedUid) {
          this.fetchLeaveOptions();
        }
        if (newVal === 'Attendance' && this.selectedUid) {
          this.fetchLeaveOptions();
        }
      }
    },
    mounted() {
      this.fetchempdetails();
    }
  };
  </script>
  
  <style scoped>
  /* Optional custom styles */
  </style>
  